import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center px-4 py-24 text-center md:px-8">
        <p className="font-heading text-6xl font-extrabold text-background-300 select-none md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-50 md:text-2xl">页面不存在</h1>
        <p className="mt-2 max-w-md text-[13px] leading-relaxed text-foreground-500">
          找不到路径为 <span className="text-foreground-300">{location.pathname}</span> 的页面。可能链接已更新，或该内容尚未收录。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <Link
            to="/"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-[13px] font-semibold text-background-950 transition hover:bg-primary-400"
          >
            回到首页
          </Link>
          <Link
            to="/category/all"
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2.5 text-[13px] text-foreground-300 transition hover:border-primary-600/70 hover:text-primary-300"
          >
            浏览全部作品
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}